
import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getMerKvs } from "@/api/api-operation-service";
import { State } from "vuex-class";
@Component
export default class SelectStation extends Vue {
  @Prop({ default: 200 }) private width!: number;
  @Prop({ default: "" }) private oprPkId!: number | string;
  @Watch("oprPkId")
  getVisible() {
    this.getStation();
  }
  @Watch("stationId")
  getValue() {
    if (this.staPkId != this.stationId) {
      this.staPkId = this.stationId;
    }
  }
  @Model("value", { type: String }) private stationId!: string;
  @State("sys") sys!: objAny;
  private stationList: object[] = [];

  private staPkId = "";

  async getStation(): Promise<void> {
    // if (this.oprPkId == "") {
    //   this.stationList = [];
    //   this.staPkId = "";
    // } else {
    if (!(this.sys.userType !== "admin" && this.oprPkId == "")) {
      const ret = await getMerKvs({ oprPkId: this.oprPkId });
      if (ret.status === this.$config.apiStatus) {
        this.stationList = ret.data;
      }
    }
    // }
  }

  public selectStation(val: string): void {
    val = val == undefined ? "" : val;
    this.staPkId = val;
    this.$emit("value", val);
    this.$emit("change", val);
  }
  mounted() {
    this.staPkId = this.stationId;
    this.getStation();
  }
}
